import { Component, ojs, app, State } from "modular-openscriptjs";
import { either, monetary } from "../../helpers";
import { dc } from "../../declarations";

const h = app("h");

export default class CompactProductCard extends Component {
    render(product, ...args) {
        const p = product instanceof State ? product.value : product;
        if (!p?.id) return h.empty();

        const imagePath = p.thumbnail_path || (p.images && p.images.length > 0 ? p.images[0].path : null);
        const price = p.final_price || p.selling_price || p.price;

        return h.div(
            {
                class: "product-card-compact flex-shrink-0 bg-white rounded-4 border shadow-sm overflow-hidden",
                style: "width: 160px; transition: transform 0.2s;",
                onclick: h.func("app('router').to", "product.view-product", { productId: p.id })
            },
            // Image
            h.div(
                { class: "bg-light", style: "height: 120px;" },
                either(
                    imagePath,
                    h.img({
                        src: imagePath,
                        class: "w-100 h-100 object-fit-cover",
                        alt: p.name
                    }),
                    h.div(
                        { class: "w-100 h-100 d-flex align-items-center justify-content-center text-muted opacity-50" },
                        h.i({ class: "bi bi-box2 fs-3" })
                    )
                )
            ),
            // Content
            h.div(
                { class: "p-2" },
                h.div(
                    { class: "fw-bold text-dark text-truncate small mb-1" },
                    p.name
                ),
                h.div(
                    { class: "fw-bold text-primary small" },
                    monetary(price, dc.userCurrency)
                )
            ),
            ...args
        );
    }
}

ojs(CompactProductCard);
